import { css } from "@emotion/css";
import { $, type Properties, resolve } from "signlets";

import { calculateBestGlideSpeed } from "../calculations";
import { feetPerMeter, metersPerNauticalMile } from "../constants";
import { indicatedToTrueAirspeed } from "../math";
import type { Drop, State } from "../model";
import { Measurement } from "./Measurement";

const style = css`
  display: grid;
  grid-template-columns: 6rem 5rem 8rem;
  gap: 1rem;
`;

export type TelemetryProps = {
  state?: State;
  drop: Drop;
};

export const Telemetry = ({ state, drop }: Properties<TelemetryProps>) => {
  const altitude = $(() => {
    const position = resolve(state)?.position;
    if (!position) return 0;
    const [, , altitude] = position;
    return altitude;
  });
  const altitudeFeet = $(() => (altitude() * feetPerMeter).toFixed(1));
  const airspeed = $(() =>
    (
      indicatedToTrueAirspeed(resolve(state)?.airspeed ?? 0, altitude()) /
      (metersPerNauticalMile / 3600)
    ).toFixed(1),
  );
  const targetAirspeed = $(() =>
    (
      indicatedToTrueAirspeed(
        calculateBestGlideSpeed(resolve(drop)),
        altitude(),
      ) /
      (metersPerNauticalMile / 3600)
    ).toFixed(1),
  );

  return (
    <div class={style}>
      <Measurement label="Altitude" value={altitudeFeet} unit="ft" />
      <Measurement label="Airspeed" value={airspeed} unit="kt" />
      <Measurement label="Target airspeed" value={targetAirspeed} unit="kt" />
    </div>
  );
};
